import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import TermsPage from "./pages/TermsPage";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import ClientDetail from "./pages/ClientDetail";
import OrderForm from "./pages/OrderForm";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEmployees from "./pages/admin/AdminEmployees";
import AdminClients from "./pages/admin/AdminClients";
import AdminAuditLog from "./pages/admin/AdminAuditLog";
import AdminLoginHistory from "./pages/admin/AdminLoginHistory";
import AdminSettings from "./pages/admin/AdminSettings";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Login only public page */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/terms" element={<TermsPage />} />

          {/* ALL routes protected */}
          <Route path="/dashboard" element={
            <ProtectedRoute><EmployeeDashboard /></ProtectedRoute>
          } />
          <Route path="/client/:id" element={
            <ProtectedRoute><ClientDetail /></ProtectedRoute>
          } />
          <Route path="/order/new" element={
            <ProtectedRoute><OrderForm /></ProtectedRoute>
          } />
          <Route path="/order/new/:clientId" element={
            <ProtectedRoute><OrderForm /></ProtectedRoute>
          } />

          {/* Admin */}
          <Route path="/admin" element={
            <ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/admin/employees" element={
            <ProtectedRoute requiredRole="admin"><AdminEmployees /></ProtectedRoute>
          } />
          <Route path="/admin/clients" element={
            <ProtectedRoute requiredRole="admin"><AdminClients /></ProtectedRoute>
          } />
          <Route path="/admin/audit" element={
            <ProtectedRoute requiredRole="admin"><AdminAuditLog /></ProtectedRoute>
          } />
          <Route path="/admin/logins" element={
            <ProtectedRoute requiredRole="admin"><AdminLoginHistory /></ProtectedRoute>
          } />
          <Route path="/admin/settings" element={
            <ProtectedRoute requiredRole="admin"><AdminSettings /></ProtectedRoute>
          } />

          {/* Catch all → login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
